import {
  Banner,
  Card,
  RadioGroupExpander,
  Typography,
} from '@oresundsbron/bridge-ui';
import { useForm, useFormParams, useSubscribe } from '@oresundsbron/use-form';
import { FC } from 'react';
import { FormButton } from '../Buttons';
import { FieldSet } from '../Fieldset';
import { InvoiceForm } from './Invoice';
import { Labels, Placeholders, Data, Disclaimers } from './types';

export type { Data } from './types';

export const PaymentMethod: FC<
  {
    labels: Labels;
    title: string;
    description: string;
    countryOptions: { key: string; value: string }[];
    placeholders: Placeholders;
    disclaimers: Disclaimers;
  } & useFormParams<Data>
> = ({
  namespace,
  title,
  defaultValues,
  onValidate,
  labels,
  description,
  countryOptions,
  placeholders,
  disclaimers,
}) => {
  const { registerField, getError, isActive, isValid, validate, stepNr } =
    useForm<Data>({ namespace, title, defaultValues, onValidate });

  const [method] = useSubscribe<Data>(namespace, 'method');

  return (
    <FieldSet nr={stepNr} title={title} id={namespace}>
      <Typography className="col-span-full">{description}</Typography>
      <RadioGroupExpander.Root
        {...registerField('method')}
        className="col-span-full"
        direction="col"
        label={labels.chooseMethod}
        required
      >
        <RadioGroupExpander.Expander
          label={labels.method.card}
          value="card"
          transparent
          disabled={!isActive}
        />
        <RadioGroupExpander.Expander
          label={labels.method.invoice}
          value="invoice"
          disabled={!isActive}
        >
          <Card.Root className="mt-4">
            <Card.Content>
              <InvoiceForm
                labels={labels}
                namespace={namespace}
                countryOptions={countryOptions}
                placeholders={placeholders}
                disclaimers={disclaimers}
              />
            </Card.Content>
          </Card.Root>
        </RadioGroupExpander.Expander>
      </RadioGroupExpander.Root>
      {getError('method') !== undefined ? (
        <Banner className="col-span-full" color="negative">
          {getError('method')}
        </Banner>
      ) : null}
      <FormButton
        loadingLabel={labels.loading}
        namespace={namespace}
        onClick={validate}
        disabled={!isActive || !isValid || !method}
      />
    </FieldSet>
  );
};
